import * as actions from './actionTypes';
import sectorService from '../services/sectorService';
import categoryService from '../services/categoryService';
import productService from '../services/productService';

// Уведомления
export const showNotification = (message, type) => ({
    type: actions.SHOW_NOTIFICATION,
    payload: { message, type }
});

export const clearNotification = () => ({
    type: actions.CLEAR_NOTIFICATION
});

// Категории проектов
export const fetchSectors = () => async (dispatch) => {
    dispatch({ type: actions.FETCH_SECTORS_REQUEST });
    
    const result = await sectorService.fetchSectorsWithProjects();
    
    if (result.success) {
        dispatch({ 
            type: actions.FETCH_SECTORS_SUCCESS, 
            payload: result.data 
        });
    } else {
        dispatch({ 
            type: actions.FETCH_SECTORS_FAILURE, 
            payload: result.error 
        });
        dispatch(showNotification(result.error, 'error'));
    }
};

export const updateSector = (sectorId, sectorData) => async (dispatch) => {
    const result = await sectorService.updateSector(sectorId, sectorData);
        
    if (result.success) {
        dispatch(showNotification('Категория успешно обновлена', 'success'));
        // Перезагружаем список всех категорий с проектами 
        dispatch(fetchSectors());
        return { success: true };
    } else {
        dispatch(showNotification(result.error, 'error'));
        return { success: false, error: result.error };
    }
};

// Категории товаров
export const fetchAllCategories = () => async (dispatch) => {
    dispatch({ type: actions.FETCH_CATEGORIES_ALL_REQUEST });

    const result = await categoryService.fetchAllCategories();

    if (result.success) {
        dispatch({
            type: actions.FETCH_CATEGORIES_ALL_SUCCESS,
            payload: result.data
        });
    } else {
        dispatch({
            type: actions.FETCH_CATEGORIES_ALL_FAILURE,
            payload: result.error
        });
        dispatch(showNotification(result.error, 'error'));
    }
};

export const fetchTopCategories = () => async (dispatch) => {
    dispatch({ type: actions.FETCH_CATEGORIES_TOP_REQUEST });

    const result = await categoryService.fetchTopCategories();

    if (result.success) {
        dispatch({
            type: actions.FETCH_CATEGORIES_TOP_SUCCESS,
            payload: result.data
        });
    } else {
        dispatch({
            type: actions.FETCH_CATEGORIES_TOP_FAILURE,
            payload: result.error
        });
        dispatch(showNotification(result.error, 'error'));
    }
};

export const deleteCategory = (categoryId, forceDelete = false) => async (dispatch) => {
    const result = await categoryService.deleteCategory(categoryId, forceDelete);
        
    if (result.success) {
        dispatch(showNotification('Категория успешно удалена', 'success'));
        // Перезагружаем список всех категорий товаров
        dispatch(fetchAllCategories());
        return { success: true };
    }
    else {
        dispatch(showNotification(result.error, 'error'));
        return { success: false, error: result.error };
    }
};

export const updateCategoryOrder = (categoriesOrder) => async (dispatch) => {
    const result = await categoryService.updateCategoryOrder(categoriesOrder);
        
    if (result.success) {
        dispatch(showNotification('Порядок категорий успешно обновлен', 'success'));
        // Перезагружаем список всех категорий товаров
        // dispatch(fetchAllCategories());
        // Обновляем порядок категорий в redux
        dispatch({
            type: actions.UPDATE_CATEGORIES_ORDER,
            payload: categoriesOrder
        });

        return { success: true };
    }
    else {
        dispatch(showNotification(result.error, 'error'));
        return { success: false, error: result.error };
    }
};

// Товары
export const fetchProductById = (id) => async (dispatch) => {
    dispatch({ type: actions.FETCH_PRODUCT_BY_ID_REQUEST });
  
    const result = await productService.fetchProductById(id);
  
    if (result.success) {
        dispatch({
            type: actions.FETCH_PRODUCT_BY_ID_SUCCESS,
            payload: result.data
        });
    } else {
        dispatch({
            type: actions.FETCH_PRODUCT_BY_ID_FAILURE,
            payload: result.error
        });
        dispatch(showNotification(result.error, 'error'));
    }
};

export const clearCurrentProduct = () => ({
    type: actions.CLEAR_CURRENT_PRODUCT
});

export const fetchProductList = (params) => async (dispatch) => {
    dispatch({ type: actions.FETCH_PRODUCT_LIST_REQUEST });
    
    let queryString;
    
    if (typeof params === 'string') {
        queryString = params;
    } else {
        // Преобразуем объект параметров в URLSearchParams
        const searchParams = new URLSearchParams();
        for (const [key, value] of Object.entries(params)) {
            if (value !== null && value !== undefined) {
                searchParams.append(key, value);
            }
        }
        queryString = searchParams.toString();
    }

    const result = await productService.fetchProductList(queryString);
    
    if (result.success) {
        dispatch({
            type: actions.FETCH_PRODUCT_LIST_SUCCESS,
            payload: result.data
        });
    } else {
        dispatch({
            type: actions.FETCH_PRODUCT_LIST_FAILURE,
            payload: result.error
        });
        dispatch(showNotification(result.error, 'error'));
    }
};

export const deleteProduct = (productId) => async (dispatch) => {
    const result = await productService.deleteProduct(productId);
        
    if (result.success) {
        dispatch(showNotification('Товар успешно удален', 'success'));
        return { success: true };
    }
    else {
        dispatch(showNotification(result.error, 'error'));
        return { success: false, error: result.error };
    }
};